// extracted by mini-css-extract-plugin
export default {"container":"uX-z","title":"vX-z","link":"wX-z"};